<script>
  import Header from "./components/UI/Header.svelte";
  import routes from "./routes/routes.js";
  import page from "page";
  
  export let locationSet=false;
  let currentPage = routes.calendar;
  function setPage({ params: { page } }) {
    currentPage = routes[page];
    // console.log("setPage", currentPage);
  };

  function updatePageMain(event) {
    page(
    "/",
    () => setPage({ params: { page: "home"} }),
    )
    currentPage = routes[event.detail]
    console.log(currentPage)

  }
  page("/:page/", setPage);
  page({ hashbang: true });
</script>
<style>
  main {
    min-height: 80%;
  }
  footer{
    padding-top: var(--space-8x)
  }
</style>
<div class="app">
  <Header 
    {currentPage}
    on:updatePage={updatePageMain}
    />
  <main>
    <svelte:component
      this={currentPage.body}
    />
  </main>
  <footer>
    <h3>MGU 2022</h3>
  </footer>
</div>


